import { render, staticRenderFns } from "./performanceList.vue?vue&type=template&id=22add0f9&scoped=true&"
import script from "./performanceList.vue?vue&type=script&lang=js&"
export * from "./performanceList.vue?vue&type=script&lang=js&"
import style0 from "./performanceList.vue?vue&type=style&index=0&id=22add0f9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22add0f9",
  null
  
)

export default component.exports